import classes from "./TermsRoute.module.css";
import { Link } from "react-router-dom";

const CsaeRoute = () => {
  return (
    <div className={classes.modal}>
      <div className={`${classes.background_wrapper}`}>
        <div className={`${classes.wrapper}`}>
          <div className={classes.info_container}>
            <p className={classes.info}>Child Sexual Abuse and Exploitation (CSAE) Policy</p>
            <p className={classes.info_brief}>Last Updated: 23-March-2025</p>
          </div>
        </div>
      </div>

      <div className={classes.privacy_content}>
        <section className={classes.section}>
          <p className={classes.p}>
          At <strong>ChatBuddies</strong>, we are committed to protecting children from online exploitation and abuse. 
          We take strong measures to prevent, report and block, and remove any content that violates child safety.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>🔹 Zero Tolerance Policy</h2>
       
          <p>
          We have a strict zero-tolerance policy towards any form of child sexual abuse material (CSAM) 
          or exploitation. Any violations will result in immediate action, including account termination 
          and reporting to authorities.
          </p>
         
       
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>🔹 Proactive Monitoring & Reporting</h2>
          <p className={classes.p}>
          Our platform uses manual moderation to identify and remove 
          inappropriate content. We cooperate with law enforcement and child protection agencies to report 
          any detected violations.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>🔹 User Reporting & Support</h2>
          <p className={classes.p}>
          We empower our users to report any suspicious or harmful content. If you encounter anything 
          concerning, please report it using our in-app reporting feature or contact our safety team at 
          <a href="mailto:info@visiontrek.in"> info@visiontrek.in</a>.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>🔹 Contact Us</h2>
          <p className={classes.p}>
            If you have any questions, concerns, or requests regarding this
            , please contact us at:
          </p>
          <p className={classes.p}>
            {/* <strong>MovieFlix.Visiontrek</strong> */}
            {/* <br></br> */}
            Email: info@visiontrek.in
            <br></br>
            Address: Phase 8 B, E 195, Phase 8B, Industrial Area, Sector 74,
            Sahibzada Ajit Singh Nagar, Punjab 160055
          </p>
        </section>
      </div>
    </div>
  );
};

export default CsaeRoute;
